   // Generating HASH out of Random String
  export const hashCode = (str) => { 
    
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    }
    
  } 

  // Creating Hex Color code out of Random String
  let hexCode
  export const intToRGB = (i) => {
    var c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;

    }  


// WEBPACK FOOTER //
// ./src/utils/colors.js